import { createListenerMiddleware, createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { ToggleOptionType } from 'components/sdk-connection-steps/sdk-connection-steps.types';
import { BucketScopeCollection } from 'hooks/use-document-list-filters/use-document-list-filters';
import { saveStorageValue } from 'hooks/use-storage/use-storage.utils';
import { RootState } from './root.types';

export const connectSliceName = 'connect';

const initialSelectedData = {
  selectedUserName: '<<username>>',
  selectedBucketName: '<<replace with your bucket name>>',
  selectedScopeName: '<<replace with your scope name>>',
  selectedCollectionName: '<<replace with your collection name>>',
};

const getInitialState = () => ({
  toogleOption: 'snippet',
  selectedData: initialSelectedData,
});

export const connectSlice = createSlice({
  name: connectSliceName,
  initialState: getInitialState(),
  reducers: {
    setPlaceholder(state) {
      state.selectedData = initialSelectedData;
    },

    reset(state) {
      Object.assign(state.selectedData, {
        selectedUserName: '',
        selectedBucketName: '',
        selectedScopeName: '',
        selectedCollectionName: '',
      });
    },

    updateUserName(state, { payload }: PayloadAction<string>) {
      state.selectedData.selectedUserName = payload;
    },

    updateBuckets(state, { payload }: PayloadAction<BucketScopeCollection>) {
      const { selectedData } = state;
      const { bucket, scope, collection } = payload;

      selectedData.selectedBucketName = bucket;
      selectedData.selectedScopeName = scope;
      selectedData.selectedCollectionName = collection;
    },

    updateToggle(state, { payload }: PayloadAction<ToggleOptionType>) {
      state.toogleOption = payload;
    },
  },
});

export default connectSlice.reducer;
export const { updateToggle, updateUserName, updateBuckets, setPlaceholder, reset } = connectSlice.actions;

export const connectListenerMiddleware = createListenerMiddleware();
connectListenerMiddleware.startListening({
  matcher: isAnyOf(updateToggle, updateUserName, updateBuckets, reset),
  effect: (_, listenerApi) => {
    saveStorageValue({ storageKey: connectSliceName, value: (listenerApi.getState() as RootState)[connectSliceName] });
  },
});
